import { useTranslation } from 'react-i18next';

import { RANGE_LABEL_KEY, RANGES } from './Costs.constants';
import { styles } from './Costs.styles';
import type { KpiCardProps, RangeToggleProps } from './Costs.types';

export const RangeToggle = ({ value, onChange }: RangeToggleProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'costs' });

	return (
		<div className={styles.rangeToggle}>
			{RANGES.map((range) => (
				<button
					key={range}
					type="button"
					aria-pressed={range === value}
					onClick={() => onChange(range)}
					className={`${styles.rangeBtn} ${range === value ? styles.rangeBtnActive : styles.rangeBtnIdle}`}
				>
					{t(RANGE_LABEL_KEY[range])}
				</button>
			))}
		</div>
	);
};

export const KpiCard = ({ label, value, sub }: KpiCardProps) => (
	<article className={styles.kpiCard}>
		<p className={styles.kpiLabel}>{label}</p>
		<p className={styles.kpiValue}>{value}</p>
		<p className={styles.kpiSub}>{sub}</p>
	</article>
);
